// ----------------------------------------------------------------------------------------------------
export const SortableTableRowStyle = {
    zIndex: 10000,
    verticalAlign: 'middle'
}
// ----------------------------------------------------------------------------------------------------
export const DraggableIconStyle = {
    cursor: 'move',
    margin: 4
}
// ----------------------------------------------------------------------------------------------------